import React, { useState, MouseEvent } from 'react';

import { NavItem, LinkItem } from './nav-item';
import { UserDropdown } from './user-dropdown';

export interface HeaderProps {
  userRoles: string;
}

export const Header: React.FC<HeaderProps> = ({ userRoles }: HeaderProps): React.ReactElement => {
  const [navToggle, setNavToggle] = useState(false);

  const userHasClaim = (claims: Array<string>): boolean => {
    let hasClaim = false;
    claims.forEach((claim) => {
      hasClaim = userRoles.includes(claim) ? true : hasClaim;
    });
    return hasClaim;
  };

  const onNavbarToggleClickHandler = (event: MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault();
    setNavToggle(!navToggle);
  };

  return (
    <nav className="app-header navbar navbar-expand-lg font-lg mb-4">
      <a className="navbar-brand" href="/">
        &nbsp;
      </a>
      <button className="navbar-toggler" type="button" onClick={onNavbarToggleClickHandler}>
        <span className="navbar-toggler-icon" />
      </button>
      <div className={`collapse ${navToggle ? 'show' : ''} navbar-collapse bg-white`} id="navbarContent">
        <ul className="ms-auto d-flex align-items-center navbar-nav me-0">
          <NavItem label="My Courses" path="/courses" exact={false} />
          <NavItem label="My Scan Results" path="/scan-results" exact={false} />

          {userHasClaim(['Teacher', 'Admin']) && (
            <NavItem label="Manage Courses" path="/courses-management" exact={false} />
          )}
          {userHasClaim(['Admin']) && (
            <NavItem label="Client Courses" path="/client-courses-management" exact={false} />
          )}
          {userHasClaim(['Admin']) && (
            <NavItem label="Global Courses" path="/global-courses-management" exact={false} />
          )}
          {userHasClaim(['Teacher', 'Admin']) && <NavItem label="Students" path="/students" exact={false} />}
          {userHasClaim(['Admin']) && <NavItem label="Admin" path="/admin" exact={false} />}
          <LinkItem url="https://help.corsmed.com/">Help</LinkItem>
          <li className="nav-item">
            <UserDropdown />
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;
